module.exports = ".sidenav-container {\n  height: 98%;\n}\n\n.sidenav {\n  width: 120px;\n}\n\n.mat-toolbar.mat-primary {\n  top: 0;\n  height: 40px;\n}\n"